import { Navigate, useLocation } from 'react-router-dom';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

function Sector7Redirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/admin/settings/sector7', search, hash }} replace />;
}

/**
 * Keep existing Sector 7 bookmarks and tab/tenant filters working inside Settings.
 * Auto-discovered by routesConfig's import.meta.glob('/src/app/**\/*Route.tsx').
 * The Settings child route enforces the SuperAdmin gate.
 */
const Sector7Route: FuseRouteItemType = {
  path: 'sector7',
  element: <Sector7Redirect />,
};

export default Sector7Route;
